import ConfirmationDialog from 'app/common/components/Confirmation/ConfirmationDialog'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import { useUpdatePurchases } from 'app/dataProviders/org/complexes/hooks'
import SimpleDate from 'app/common/classes/simple-date'
import { OrgId } from 'app/dataTypes/org'
import { OrgComplexId } from 'app/dataTypes/org/complexes'
import usePopup from 'app/common/hooks/usePopup'

type Props = {
  date: SimpleDate
  orgId: OrgId
  orgComplexId: OrgComplexId
}

export const UpdatePurchasesLink = ({ date, orgId, orgComplexId }: Props) => {
  const popup = usePopup()

  const { requestRef, loading } = useUpdatePurchases({
    initialLodaing: false,
    autoload: false,
    params: {
      date,
      orgId,
      orgComplexId,
    },
  })

  const handleUpdatePurchases = async () => {
    const res = await requestRef.current()
    if (res) {
      popup('Стоимость комплекта была успешно обновлена')
    }
  }

  return (
    <ConfirmationDialog // TODO поменять на аналогичный из ui-next
      onConfirm={handleUpdatePurchases}
      text={`Обновить стоимость комплекта во всех продажах за ${date.getStringFormatted('DD.MM.YYYY')}?`}
      confirmButtonText="Обновить"
    >
      {(handleConfirm) => (
        <PlainButtonAsLink onClick={handleConfirm} disabled={loading}>
          {'Обновить стоимость в продажах'}
        </PlainButtonAsLink>
      )}
    </ConfirmationDialog>
  )
}
